import { Card, Image } from "antd";
import { useTranslation } from "react-i18next";
import introduction1 from "../../images/introduction1.png";
import introduction2 from "../../images/introduction2.png";
import introduction3 from "../../images/introduction3.png";
import styles from "./style.module.scss";

const Introduction = () => {
  const { t } = useTranslation();

  const introductionEnum = [
    {
      key: "introduction1",
      src: introduction1,
      question: t("home.introduction.quesion1"),
      answer: t("home.introduction.answer1"),
    },
    {
      key: "introduction2",
      src: introduction2,
      question: t("home.introduction.quesion2"),
      answer: t("home.introduction.answer2"),
    },
    {
      key: "introduction3",
      src: introduction3,
      question: t("home.introduction.quesion3"),
      answer: t("home.introduction.answer3"),
    },
  ];

  const renderCard = (item, index) => {
    return (
      <Card className={styles.card} key={index}>
        <Image src={item.src} alt={item.key} preview={false} className={styles.img} />
        <div className={styles.question}>{item.question}</div>
        <div className={styles.answer}>{item.answer}</div>
      </Card>
    );
  };

  return (
    <div className={styles.introduction}>
      {introductionEnum.map((item, index) => {
        return renderCard(item, index);
      })}
    </div>
  );
};

export default Introduction;
